import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import {
  isPersonalMissionMessageMessage,
  type PersonalMissionMessageMessage,
} from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalMissionHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalMissionMessageMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalMissionMessageMessage(payload);
  }

  handle(payload: PersonalMissionMessageMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작 없음
  }
}
